module.exports = __webpack_public_path__ + "static/dallas_county.3e7575e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/dallas_county.png
// module id = 2218
// module chunks = 61762850755587